const pushSarbacane = {
    ui: {},

    init: function () {
        this.bindUI()
        this.bindEvents()
    },

    bindUI: function bindUI() {
        this.ui.$pushSarbacane = $(".js-push-sarbacane");
    },

    bindEvents: function bindEvents() {
        this.ui.$pushSarbacane.on('submit', this.loadMore.bind(this));
    },

    loadMore: function (e) {
        e.preventDefault();
        let $this = $(e.currentTarget);
        let $ajaxLoader = $this.find('.js-ajaxLoader');
        let $submitText = $this.find('.js-push-sarbacane-submit-text');
        let $messageSuccess = $this.find('.js-push-sarbacane-message-success');
        let $messageError = $this.find('.js-push-sarbacane-message-error');

        if (!$ajaxLoader.hasClass('loaderAnimation--is-hidden')) {
            return false;
        }

        $ajaxLoader.removeClass('loaderAnimation--is-hidden');
        $submitText.hide();
        $messageSuccess.hide();
        $messageError.hide();

        var form_data = new FormData($this[0]);
        form_data.append('action', 'push_email_sarbacane');

        $.ajax({
            url: wordpress_vars.ajax_url,
            type: 'POST',
            contentType: false,
            processData: false,
            data: form_data,
            success: (response) => {
                $ajaxLoader.addClass('loaderAnimation--is-hidden');
                $submitText.show();

                if (response === 'error') {
                    $messageError.show();
                } else {
                    $messageSuccess.show();
                }
            },
            error: (response) => {
                console.log(response);
                $ajaxLoader.addClass('loaderAnimation--is-hidden');
                $submitText.show();
                $messageError.show();
            },
        })
    },
}

module.exports = pushSarbacane
